import React from 'react';
import ReactDOM from 'react-dom';
import {AiOutlineCloseCircle} from 'react-icons/ai';


const ThankYou = ({ isShowing, hide }) => isShowing ? ReactDOM.createPortal(
  <React.Fragment>
    <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
    <div className="modal-overlay" onClick={hide}/>
      <div className="modal">
        <div className="modal-header">
          <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
            <span aria-hidden="true"><AiOutlineCloseCircle/></span>
          </button>
        </div>
        <div className='center'>
          <h2>Thank you for your Participation!</h2>
        </div>
      </div>
    </div>
  </React.Fragment>, document.body
  ) : null;

export default ThankYou
